export default {
  menu: {
    projects: "Invertir",
    about: "Acerca de",
    user: "Usuario",
    dashboard: "Dashboard",
    dashboard_admin:"Panel",
    login: "Ingresar",
    signup: "Registrarse",
    restore_password: "Recuperar contraseña",
    profile: "Mi Perfil",
    notifications: "Notificaciones",
    investments: "Inversiones",
    portfolio: "Portafolio",
    dashboard: "Panel Administrativo",
    help: "Ayuda",
    logout: "Cerrar Sesión"
  },
  login:{
    email: "Correo",
    password: "Contraseña",
    button_start: "Ingresar",
    button_forgot: "¿Olvidé mi contraseña?",
    have_account: "¿Tienes una cuenta?"
  },
  signup: {
    button: "Registrarme"
  },
  restore: {
    button: "Restaurar"
  },
  detail: {
    button_more: "Ver más"
  },
  index: {
    title: 'Oportunidades de Inversión',
    subtitle: 'Ofertas abiertas',
    title_closed: 'Inversiones cerradas',
    button_investment: 'Invertir'
  },
  profile:{
    title: "Perfil",
    password: "Contraseña",
    password_confirm: "Confirmar Contraseña",
    button_change: "Cambiar contraseña",
    title_1: "Cambiar contraseña",
    title_2: "Firma digital",
    profile: "Perfil",
    password: "Contraseña",
    signature: "Firma Digital",
    qualify: "¿Calificado?",
    qualify_yes: "Si",
    qualify_no: "No",
    button_profile: "Guardar",
    button_signature: "Generar"
  },
  notifications: {
    title: "Notificaciones",
    status_news: "Nuevas",
    status_readed: "Leídas",
    status_archived: "Archivadas"
  },
  unconfirm: {
    message: "Hemos enviado un correo al email registrado. Por favor confirma tu cuenta antes de comenzar",
    redirect: "Serás redireccionado"
  },
  settings: {
    title: "Panel Administrativo",
    projects: "Proyectos",
    users: "Usuarios",
    roles: "Perfiles de usuario",
    permissions: "Recursos del Rol",
    configs: "Configuraciones",
    button_save: "Guardar",
    button_cancel: "Cancelar"
  },
  projects: {
    name: "Nombre",
    date_start: "Inicia",
    date_end: "Finaliza",
    summary: "Resumen",
    ammount_total: "Monto total",
    ammount_recauded: "Recaudado",
    project_type: "Tipo",
    status: "Estatus",
    btn_change_stage: "Etapa actual",
    btn_add_ammount: "Agregar",
    media_title: "Imágenes",
    info_title:"Datos del Proyecto",
    media_data_max_size: "Archivos jpg/png con un tamaño menor de 5MB",
    ammount_investment: "Montos de inversión",
    documents: "Prospecto",
    borrador: "Borrador",
    abierto: "Abierto",
    cerrado: "Cerrado"
  },
  users: {
    name: "Nombre",
    email: "Correo electrónico",
    status: "Estatus",
    origin: "Origen",
    registered_at: "Registro",
    qualify: "Calificado",
    phone: "Teléfono",
    terms_conditions: "Acepto los términos y condiciones",
    address: "Dirección"
  },
  roles: {
    name: "Nombre"
  },
  alerts: {
    title: "Notificaciones",
    date: "Fecha",
    subject: "Asunto"
  },
  investment: {
    title: "Mis Inversiones",
    registered_at: "Registro",
    ammount_investment: "Inversión",
    ammount_recauded: "Recaudado",
    confirmed_at: "Confirmado",
    project_name: "Proyecto",
    status: "Estatus",
    reference_payment: "Referencia de Pago",
    button_prev: "Atrás",
    button_next: "Siguiente",
    button_end: "Finalizar",
    porautorizar: "Por autorizar",
    autorizado: "Autorizado",
    pendientedepago: "Pendiente de Pago",
    confirmaciondepago: "Pago por confirmar",
    pagoconfirmado: "Pago confirmado",
    solicituddedocumentos: "Solicitud de documentos",
    rechazado: "Rechazado",
    finalizado: "Finalizado"
  },
  portfolio: {
    title: "Mi Portafolio",
    registered_at: "Registro",
    ammount_investment: "Inversión",
    ammount_recauded: "Recaudado",
    confirmed_at: "Confirmado",
    project_name: "Proyecto"
  },
  configurations: {
    name: "Nombre"
  },
  helpcenter:{
    title: "Centro de Ayuda"
  }
}
